module.exports = __webpack_public_path__ + "assets1662726319812/img/avator.bd584bb1.png";